import type {
  EffectPower,
  SchemaGroup,
  ScrollEffectConfig,
  ScrollEffectParams,
} from '../types';
import {
  power,
  range,
  scrollOffsetFull,
  rangeInOut,
  screenCenter,
  screenEnter,
  screenLeave,
} from './baseParams';

export interface StretchScroll extends ScrollEffectParams {
  power?: EffectPower;
  stretch?: number;
}

const name = 'StretchScroll';
const groups: SchemaGroup[] = ['scroll', 'animation'];

export const config: ScrollEffectConfig<StretchScroll> = {
  name,
  groups,
  range: { ...range, default: 'out' },
  schema: {
    in: {
      start: { ...screenEnter },
      end: { ...screenCenter },
      power: { ...power, default: 'hard' },
    },
    out: {
      start: { ...screenCenter },
      end: { ...screenLeave },
      power: { ...power, default: 'hard' },
    },
    continuous: {
      start: { ...screenEnter },
      end: { ...screenLeave },
      power: { ...power, default: 'hard' },
    },
  },
} as const;

export const responsiveConfig: ScrollEffectConfig<StretchScroll> = {
  name,
  groups,
  range: { ...rangeInOut, default: 'out' },
  schema: {
    in: {
      start: { ...scrollOffsetFull },
      end: { ...scrollOffsetFull, default: 50 },
      stretch: {
        type: 'number',
        min: 0.2,
        max: 0.6,
        step: 0.1,
        default: 0.4,
      },
    },
    out: {
      start: { ...scrollOffsetFull, default: 50 },
      end: { ...scrollOffsetFull, default: 100 },
      stretch: {
        type: 'number',
        min: 0.2,
        max: 0.6,
        step: 0.1,
        default: 0.4,
      },
    },
  },
} as const;
